import { SettingsNavigation, type SettingsNavigationItem } from '../SettingsNavigation'

const ITEMS: SettingsNavigationItem[] = [
  {
    id: 'settings-tab-subscription-billing',
    label: 'Abonnementdaten & Rechnung',
    to: '/settings/subscription',
  },
  {
    id: 'settings-tab-subscription-contract',
    label: 'Abonnement',
    to: '/settings/subscription/contract',
  },
  {
    id: 'settings-tab-subscription-gdpr',
    label: 'Datenexport (DSGVO)',
    to: '/settings/subscription/gdpr-export',
  },
]

export function SubscriptionSettingsNav() {
  return <SettingsNavigation items={ITEMS} />
}
